(function() {
  'use strict';

  angular.module('component.blueprints')
    .component('blueprintMaps', {
      templateUrl: 'app/components/blueprints/blueprintMaps.list.html',
      controller: 'BlueprintMapsController',
      controllerAs: 'blueprintMapsCtrl'
    });
})();
